module.exports = __webpack_public_path__ + "img/平静.65489d3a.png";